/* global axios */
import ApiClient from './ApiClient';

class OfferGroupsAPI extends ApiClient {
  constructor() {
    super('offer_groups', { accountScoped: true });
  }

  list() {
    return axios.get(this.url);
  }

  create(name) {
    return axios.post(this.url, { offer_group: { name } });
  }

  update(id, name) {
    return axios.put(`${this.url}/${id}`, { offer_group: { name } });
  }

  destroy(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default new OfferGroupsAPI();
